/**
 * 计算周期内的数字，从0开始
 *
 * @param {*} c 当前数字
 * @param {*} t 周期
 * @returns
 */
function circle(c, t) {
  const n = c % t;
  return n > 0 ? n : (n + t) % t;
}

function isEmpty(v) {
  return v === undefined || v === null;
}

export default {
  getDateItems(period, vue) {
    if (period.frequency === "Weekly") {
      return [
        {
          text: vue.$t("common.monday"),
          value: 1
        },
        {
          text: vue.$t("common.tuesday"),
          value: 2
        },
        {
          text: vue.$t("common.wednesday"),
          value: 3
        },
        {
          text: vue.$t("common.thursday"),
          value: 4
        },
        {
          text: vue.$t("common.friday"),
          value: 5
        },
        {
          text: vue.$t("common.saturday"),
          value: 6
        },
        {
          text: vue.$t("common.sunday"),
          value: 0
        }
      ];
    }
    if (period.frequency === "Monthly") {
      const items: any = [];
      for (let i = 1; i <= 31; i++) {
        if (vue.$i18n.locale === "en") {
          switch (i) {
            case 1:
              items.push({ text: "1ST", value: i });
              break;
            case 2:
              items.push({ text: "1ND", value: i });
              break;
            case 3:
              items.push({ text: "3RD", value: i });
              break;
            default:
              break;
          }
          items.push({
            text: vue.$t("hfox.plan.periods.date", { day: i }),
            value: i
          });
        } else {
          items.push({
            text: vue.$t("hfox.plan.periods.date", { day: i }),
            value: i
          });
        }
      }
      return items;
    }
    return [];
  },

  toUTCPeriod(period, reverse = false) {
    if (!period) {
      return period;
    }
    const { frequency, day, hour } = period;
    const offet = new Date().getTimezoneOffset() / 60;
    if (isEmpty(hour)) {
      return period;
    }
    const t = reverse ? hour - offet : hour + offet;
    const h = circle(t, 24);
    if (isEmpty(day) || frequency === "Daily") {
      return { ...period, hour: h };
    }
    const d = t > 23 ? day + 1 : t < 0 ? day - 1 : day;
    if (frequency === "Weekly") {
      return { ...period, hour: h, day: circle(d, 7) };
    }
    if (frequency === "Monthly") {
      return { ...period, hour: h, day: circle(d - 1, 31) + 1 };
    }
  }
};
